
import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class ClassRecordSummaryTableRow {
	constructor(el) {
		this.el = el;
		this.ClassRecordId = parseInt(el.getAttribute('data-classrecord-id'));
		this.el.addEventListener('click', (evt)=>{
			evt.stopPropagation(); evt.preventDefault();
			document.location = `/classrecord/${this.ClassRecordId}/edit`;
		});
	}
}